import { Component, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { DocumentLinkTypeEnum } from '../../../know-how/enums/document-type.enum';
import { KnowHowService } from '../../../know-how/services/know-how.service';
import { SharedToasterService } from '../../../shared/services/shared-toaster.service';

@Component({
    templateUrl: './document-link-display-modal.component.html',
    styleUrl: './document-link-display-modal.component.scss'
})
export class DocumentLinkDisplayModalComponent implements OnInit {
    @Input({ required: true }) name!: string;
    @Input({ required: true }) documentId!: string;
    @Input({ required: true }) linkUrl!: string | null;
    @Input({ required: true }) type!: DocumentLinkTypeEnum;
    @Input({ required: true }) acceptanceDeadlineUtc!: Date | null;
    @Input({ required: true }) isReadByUser!: boolean;

    @Output() onDocumentRead: Subject<void> = new Subject<void>();

    protected isLoading: boolean = false;
    protected modalTitleKey: string = '';
    protected documentLinkUrl: string | null = null;

    // ToDo: Testtings for other file open options
    // protected safeUrl: SafeResourceUrl | null = null;

    protected documentLinkTypeEnum = DocumentLinkTypeEnum;

    constructor(
        private knowHowService: KnowHowService,
        private sharedToasterService: SharedToasterService,

        // ToDo: Testtings for other file open options
        // private sanitizer: DomSanitizer
    ) { }


    ngOnInit(): void {
        this.setModalTitleKey();

        if (this.documentId != null) {
            this.downloadDocumentFile(this.documentId);
        }
    }

    protected onSubmit(): void {
    }

    protected markAsRead(): void {
        this.knowHowService.markDocumentAsRead(this.documentId).subscribe({
            next: () => {
                this.isReadByUser = true;
                this.onDocumentRead.next();
            }
        });
    }

    private setModalTitleKey(): void {
        if (this.documentId != null) {
            this.modalTitleKey = 'documentLink.displayDocument';
        }

        if (this.linkUrl != null) {
            this.modalTitleKey = 'documentLink.displayAndConfirmLink';
        }
    }

    private downloadDocumentFile(documentId: string): void {

        // use this for direct file download:
        this.documentLinkUrl = this.knowHowService.getDocumentUrl(documentId);

        // use this to preload the file
        // this.knowHowService.downloadDocumentFile(documentId).subscribe({
        //     next: (blob) => {
        //         const blobUrl = URL.createObjectURL(blob);
        //         this.documentLinkUrl = blobUrl;
        //     },
        //     error: (error) => {
        //         this.sharedToasterService.showGeneralDataLoadingError();
        //     }
        // });
    }
}
